module.exports = __webpack_public_path__ + "static/15-01749728e02da675ee6960941b186986.png";